// Schema and mapper for Salesforce Project_Qualification_Step__c

export function fromSalesforceProjectQualStep(sfRecord) {
  const data = {
    info: {
      name: "",
      projectId: "",
      projectName: "",
      projectObjectiveId: "",
      projectObjectiveName: "",
      passingScore: "",
      status: "",
      qualificationStepId: "",
      qualificationStepName: "",
      funnel: "",
      stepNumber: "",
      numberOfAttempts: "",
      estimatedTimeMinutes: "",
    },
    sys: {
      createdById: "",
      lastModifiedById: "",
    },
  };

  if (!sfRecord || typeof sfRecord !== "object") return { id: null, ...data };

  data.info.name = sfRecord.Name || "";
  data.info.projectId = sfRecord.Project__c || "";
  data.info.projectName = sfRecord.Project__r?.Name || "";
  data.info.projectObjectiveId = sfRecord.Project_Objective__c || "";
  data.info.projectObjectiveName = sfRecord.Project_Objective__r?.Name || "";
  data.info.passingScore = sfRecord.Passing_Score__c ?? "";
  data.info.status = sfRecord.Project_Qualification_Step_Status__c || "";
  data.info.qualificationStepId = sfRecord.Qualification_Step__c || "";
  data.info.qualificationStepName = sfRecord.Qualification_Step__r?.Name || "";
  data.info.funnel = sfRecord.Funnel__c || "";
  data.info.stepNumber = sfRecord.Step_Number__c ?? "";
  data.info.numberOfAttempts = sfRecord.Number_of_Attempts__c ?? "";
  data.info.estimatedTimeMinutes =
    sfRecord.Estimated_Time_to_Complete_mins__c ?? "";

  data.sys.createdById = sfRecord.CreatedById || "";
  data.sys.lastModifiedById = sfRecord.LastModifiedById || "";

  const id = sfRecord.Id || null;
  return { id, ...data };
}

// Mapper for PATCH/UPDATE for Qualification Step
export function toSalesforceProjectQualStep(uiRecord) {
  const rec = {};
  if (!uiRecord || typeof uiRecord !== "object") return rec;
  const info = uiRecord.info || {};
  if (uiRecord.id) rec.Id = uiRecord.id;
  if (info.name !== undefined) rec.Name = info.name || null;
  if (info.projectId !== undefined) rec.Project__c = info.projectId || null;
  if (info.projectObjectiveId !== undefined)
    rec.Project_Objective__c = info.projectObjectiveId || null;
  if (info.passingScore !== undefined) rec.Passing_Score__c = info.passingScore;
  if (info.status !== undefined)
    rec.Project_Qualification_Step_Status__c = info.status || null;
  if (info.qualificationStepId !== undefined)
    rec.Qualification_Step__c = info.qualificationStepId || null;
  if (info.funnel !== undefined) rec.Funnel__c = info.funnel || null;
  if (info.stepNumber !== undefined) rec.Step_Number__c = info.stepNumber;
  if (info.numberOfAttempts !== undefined)
    rec.Number_of_Attempts__c = info.numberOfAttempts;
  if (info.estimatedTimeMinutes !== undefined)
    rec.Estimated_Time_to_Complete_mins__c = info.estimatedTimeMinutes;
  return rec;
}
